export function removeEmptyProperties(object) {
  const objectCopy = JSON.parse(JSON.stringify(object));
  for (const key in objectCopy) {
    if (objectCopy[key] === "" || objectCopy[key] === "null") {
      delete objectCopy[key];
    }
  }
  return objectCopy;
}
